<template>
    <div class="page">
        <div class="home-container">
            <h1>Kiinalaisen lääketieteen hoitoja Lohjalla ja Espoossa - akupunktio, kuivakuppaus, tulineula <br /> <br /> Tervetuloa</h1>
            <p>
                Nimeni on Tiia Koli ja olen perustanut syksyllä 2023 Koliklinikka-nimisen yrityksen, joka tarjoaa kiinalaisen lääketieteen hoitoja Lohjalla ja Espoossa.
                Toimin sivutoimisena yrittäjänä anestesiasairaanhoitajan työni ohella.
                Kiinalaisen lääketieteen hoitoja en tee sairaanhoitajana vaan akupunktiohoitajana.
            </p>
            <img src="@/assets/bikelogo2.jpg" alt="Bike with logo">
            <div class="info-container">
                <h2>Mitä kaikkea kiinalaisen lääketieteen avulla voidaan hoitaa?</h2>
                <p>
                    <ul class="inline-list">
                        <li>erilaiset kivut, niin akuutit kuin krooniset</li>
                        <li>migreeni, päänsärky</li>
                        <li>bruksismi</li>
                        <li>kiristävät ja tummat arvet</li>
                        <li>puutuminen ja tunnottomuus</li>
                        <li>turvotus</li>
                        <li>vapina</li>
                        <li>lihasten jäykkyys</li>
                        <li>ihottumat</li>
                        <li>allergia</li>
                        <li>virus- ja bakteeritaudit sekä niiden jälkitilat</li>
                        <li>poskiontelotulehdus</li>
                        <li>ruoansulatusvaivat</li>
                        <li>stressi, uupumus</li>
                        <li>uniongelmat</li>
                        <li>kuukautishäiriöt</li>
                        <li>synnytyksen käynnistäminen</li>
                        <li>vauvan kääntö perätilasta</li>
                        <li>hedelmättömyys</li>
                    </ul>
                </p>
                <p>
                    Hoidettavasta asiasta riippuen osa parantuu ensimmäisen hoitokerran jälkeen ja osa saattaa vaatia pidemmän hoitosarjan.
                    Hyvänä nyrkkisääntönä voidaan pitää, että mitä pidempään vaiva on jatkunut sitä useamman hoitokerran se vaatii.
                    Vastaanotolle tullessasi tehdään alkuun kattava haastattelu ja kuunnellaan pulssi molemmista ranteista. Diagnoosin tekemisen jälkeen valitaan asikkaan tarpeiden ja toiveiden mukaan paras mahdollinen hoitomuoto.
                    Ensimmäisellä hoitokerralla tehdään henkilökohtainen hoitosuunnitelma, jossa otetaan juuri sinun tilanteesi ja voimavarasi huomioon.
                </p>
            </div>
            <div class="button-container">
                <router-link to="/hoidot" class="btn btn-primary">Lue lisää hoidoista</router-link>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'HomePage'
    };
</script>

<style scoped>
    .home-container {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
    }

    .home-container h1 {
        text-align: center;
    }

    .info-container {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        flex-direction: column;
    }

    .inline-list {
        display: inline-block;
        margin: 0;
        padding: 0;
        list-style-type: disc;
    }

        .inline-list li {
            display: list-item;
            list-style-position: inside;
        }

    .page img {
        width: 70%;
        height: auto;
        object-fit: cover;
        border-radius: 8px;
        margin-bottom: 30px;
    }

    .btn {
        display: inline-block;
        padding: 10px 20px;
        margin-top: 20px;
        font-size: 1rem;
        text-align: center;
        text-decoration: none;
        color: #fff;
        background-color: #007bff;
        border: none;
        border-radius: 5px;
        cursor: pointer;
        transition: background-color 0.3s;
    }

    .btn-primary {
        background-color: #E2CFC9;
        color: black;
    }

        .btn-primary:hover {
            background-color: #bc9a94;
        }

    .button-container {
        margin-bottom: 20px;
    }
</style>
